import { Component, Input } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-rotate-chevron',
  templateUrl: './rotate-chevron.component.html',
  styleUrls: ['./rotate-chevron.component.scss'],
  animations: [
    trigger('rotatedState', [
      state('up', style({ transform: 'rotate(0)' })),
      state('down', style({ transform: 'rotate(-180deg)' })),
      transition('down <=> up', animate('100ms ease-out')),
    ]),
  ],
})
export class RotateChevronComponent {
  public state = 'up';

  @Input()
  public set rotate(value: boolean) {
    this.state = value ? 'down' : 'up';
  }
}
